import React from 'react';
import { ReactComponent as MinusIcon } from '../../../../components/Common/BootstrapIcons/dash.svg';
import { ReactComponent as PlusIcon } from '../../../../components/Common/BootstrapIcons/plus.svg';
import CustomIcon from '../../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../../Common/BootstrapIcons/Tooltip/IconTooltip';
import { ReactComponent as DownloadIcon } from '../../../Common/BootstrapIcons/download.svg';
import { ReactComponent as UploadIcon } from '../../../Common/BootstrapIcons/upload.svg';
import httpClient from '../../../../infrastructure/helpers/common/httpClient';
import urlHelper from '../../../../infrastructure/helpers/common/urlHelper';
import UploadFileModal from '../../../Common/Modals/UploadFileModal/UploadFIleModal';
import reportConfigNavigation from '../../../../infrastructure/helpers/report/navigation/reportConfigNavigation';
import { mapToSelectSearchOption } from '../../../../infrastructure/helpers/html/selectOptionHelper';
import SearchValidationType from '../../../../types/report/SearchValidationType';
import SelectSearch, { SelectedOptionValue } from 'react-select-search';
import './ValidationSection.scss';
import ReportCollections from '../../../../infrastructure/types/Functions/ReportCollections';
import ReportConfig from '../../../../types/report/ReportConfig';
import AccuracyValidation from '../../../../types/report/AccuracyValidation';
import ValidationFilter from '../../../../types/report/ValidationFilter';
import messageHelper from '../../../Common/Message/MessageHelper';
import navigationHelper from '../../../../infrastructure/helpers/common/navigation/navigation';
import { ReactComponent as SearchIcon } from '../../../Common/BootstrapIcons/search.svg';
import { ReactComponent as ClearIcon } from '../../../Common/BootstrapIcons/close.svg';
interface Props {
    heading: string;
    htmlId: string;
    onClick: (htmlId: string) => void;
    isExpanded: (htmlId: string) => boolean;
    regime: string;
    validationKind: string;
    searchNames: string[];
    reportConfig: ReportConfig,
    collections: ReportCollections,
    onSearchBySelected: (value: string) => void;
    onClearSearchClick: () => void;
    onSearchStarted: () => void;
    onSearchFinished: (validations: AccuracyValidation[]) => Promise<void>;
    sectionId: string;
    isReadOnly: boolean;
}

interface State {
    showFileUploadPopup: boolean,
    showSearchPopup: boolean,
    searchBy: string,
    searchForValue: string,
    showSearchSpinner: boolean
}

const defaultSearchByOption = 'Search By ';
class ValidationSection extends React.Component<Props, State>{

    constructor(props: Props) {
        super(props);

        this.state = {
            showFileUploadPopup: false,
            showSearchPopup: false,
            searchBy: defaultSearchByOption,
            searchForValue: '',
            showSearchSpinner: false
        }

        this.onClick = this.onClick.bind(this);
        this.onUploadValidationsClick = this.onUploadValidationsClick.bind(this);
        this.onDownloadValidationsClick = this.onDownloadValidationsClick.bind(this);
        this.onUploadFilePicked = this.onUploadFilePicked.bind(this);
        this.onValidationsUpdated = this.onValidationsUpdated.bind(this);
        this.onSearchBySelected = this.onSearchBySelected.bind(this);
        this.onSearchClick = this.onSearchClick.bind(this);
        this.onSearchForValueSelected = this.onSearchForValueSelected.bind(this);
        this.onClearSearchClick = this.onClearSearchClick.bind(this);
    }

    onUploadValidationsClick() {
        this.setState({ showFileUploadPopup: true });
    }

    getUploadData(file: File): FormData {
        let data = new FormData();

        data.append('file', file as File);

        return data;
    }

    async onDownloadValidationsClick() {

        let route = urlHelper.buildRoute(['report', 'validations', this.props.validationKind, this.props.regime]);

        await httpClient.download(route);

        this.setState({ showFileUploadPopup: false });
    }

    onClick(): void {
        this.props.onClick(this.props.htmlId);
    }

    getClassName(): string {
        let classes = ['collapse'];

        if (this.props.isExpanded(this.props.htmlId)) {
            classes.push('show');
        }

        return classes.join(' ');
    }

    resolveIcon(): JSX.Element {

        return this.props.isExpanded(this.props.htmlId) ? <MinusIcon /> : <PlusIcon />;
    }

    resolveTooltip(): string {

        return this.props.isExpanded(this.props.htmlId) ? 'collapse' : 'expand';
    }

    onValidationsUpdated() {
        navigationHelper.refreshPage();

        let message = 'Bulk update completed. Please change history.';

        messageHelper.showMesage(message, true);
    }

    async onUploadFilePicked(files: FileList): Promise<void> {

        let data = this.getUploadData(files[0]);

        var path = urlHelper.buildRoute(['report', 'validations', this.props.validationKind, this.props.regime]);

        await httpClient.postFile(path, data, {});

        this.setState({ showFileUploadPopup: false }, this.onValidationsUpdated);
    }

    async onSearchClick(): Promise<void> {
        if (this.state.searchBy.toString() !== defaultSearchByOption && this.state.searchForValue) {

            this.props.onSearchStarted();

            this.setState({ showSearchSpinner: true });

            let url = 'report/validations/filter';

            let response = await httpClient.post(url, {
                validationKind: this.props.validationKind,
                filterType: this.state.searchBy.split(' ').join(''),
                filterValue: this.state.searchForValue,
                reportConfig: this.props.reportConfig
            } as ValidationFilter);

            this.setState({ showSearchSpinner: false });

            let validations: AccuracyValidation[] = response.data || [];

            validations.forEach((validation: AccuracyValidation) => {
                validation.errors = [];
            });

            await this.props.onSearchFinished(validations);
        }
    }

    onSearchForValueSelected(value: SelectedOptionValue | SelectedOptionValue[]): void {
        this.setState({ searchForValue: value.toString() });
    }

    onSearchBySelected(value: SelectedOptionValue | SelectedOptionValue[]): void {

        let val = value.toString();

        if (val !== defaultSearchByOption) {
            this.setState({ searchForValue: '', searchBy: val });
            this.props.onSearchBySelected(val);
        }
    }

    onClearSearchClick() {
        this.setState({ searchBy: defaultSearchByOption, searchForValue: '' });
        this.props.onClearSearchClick();
    }

    getItem(actionItem: string) {
        return { id: actionItem, name: actionItem, item: actionItem, preventDelete: false };
    }

    render(): JSX.Element {
        return (
            <>
                <div className="section-heading" style={{ paddingLeft: '25px' }}>
                    <div className='display-flex  flex-align-center'>
                        <div className='width-250px display-flex'>
                            <h5 id={this.props.htmlId}>
                                {this.props.heading}
                            </h5>
                            <button id={`btn-expand-${this.props.htmlId}`} className="transparent-button" onClick={this.onClick} title={this.resolveTooltip()}>
                                {this.resolveIcon()}
                            </button>
                        </div>
                        <div className='validation-search-container' id={this.props.sectionId} >
                            <div className='display-flex place-items-center'>
                                <div className='display-flex align-items-center'>
                                    <SelectSearch
                                        placeholder={defaultSearchByOption}
                                        value={this.state.searchBy}
                                        options={[SearchValidationType.refDataSourceName, SearchValidationType.fieldName, SearchValidationType.variableName].map(mapToSelectSearchOption)}
                                        onChange={this.onSearchBySelected} />
                                </div>
                                <div className='margin-left-10px'>
                                    <SelectSearch
                                        placeholder='Search For'
                                        search={true}
                                        value={this.state.searchForValue}
                                        options={this.props.searchNames.map(mapToSelectSearchOption)}
                                        onChange={this.onSearchForValueSelected} />
                                </div>
                                <div className='margin-left-10px'>
                                    <button className='custom-icon-button autocomplete-button' onClick={this.onSearchClick}>
                                        <CustomIcon icon={SearchIcon} title={iconTooltip.search} />
                                    </button>
                                </div>
                                <div className='margin-left-10px'>
                                    <button className='custom-icon-button autocomplete-button' onClick={this.onClearSearchClick}>
                                        <CustomIcon icon={ClearIcon} title={iconTooltip.clear} />
                                    </button>
                                </div>
                            </div>
                            <div id='searchValidationsButtons'>
                                <button type="button" className="bg-none border-none" onClick={this.onDownloadValidationsClick}>
                                    <CustomIcon icon={DownloadIcon} title={iconTooltip.download} />
                                </button>
                                <button type="button" className="bg-none border-none" onClick={this.onUploadValidationsClick}>
                                    <CustomIcon icon={UploadIcon} title={iconTooltip.upload} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div >

                <div className={this.getClassName()} style={{ paddingLeft: '25px' }}>
                    {this.props.children}
                </div>
                {
                    this.state.showFileUploadPopup &&
                    <UploadFileModal
                        allowedExtensions={['csv']}
                        onClose={() => { this.setState({ showFileUploadPopup: false }) }}
                        uniqueName='validationsUpload'
                        onFilePicked={this.onUploadFilePicked}
                    />
                }
            </>
        );
    }
}

export default ValidationSection;
